const imageUrls = [
    "https://img2.baidu.com/it/u=920962832,3035141568&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=500",
    "https://img1.baidu.com/it/u=1774573657,812320405&fm=253&fmt=auto&app=138&f=JPEG?w=821&h=500",
    "https://img0.baidu.com/it/u=1033493412,1236548540&fm=253&fmt=auto&app=138&f=JPEG?w=888&h=498",
    "https://img1.baidu.com/it/u=2207166594,3278271905&fm=253&fmt=auto&app=138&f=JPG?w=889&h=500",
    "https://img0.baidu.com/it/u=1663819966,3704744076&fm=253&fmt=auto&app=138&f=JPEG?w=750&h=360"
]

export default imageUrls